module.exports = __webpack_public_path__ + "assets/img/5.045834c4.png";